module.exports = __webpack_public_path__ + "assets/img/22_222.da16840a.jpg";